
      (window.__NEXT_P = window.__NEXT_P || []).push([
        "/blogCategory",
        function () {
          return require("private-next-pages/blogCategory/index.js");
        }
      ]);
    